import axios from 'axios';
import downloadjs from 'downloadjs';
import moment from 'moment';

import { DATE_FORMAT } from 'constant';
import configs from 'configs';

import { isDict, isArray, removeAccent } from './misc';
import { notifyError } from './notify';

const { accApiUrl, fileServiceUrl } = configs;

const processRequestData = (data) => {
  if (!data || !isDict(data)) return data;

  const clone = { ...data };
  Object.keys(data).forEach((key) => {
    const val = data[key];
    if (val instanceof moment) {
      clone[key] = val.format(DATE_FORMAT);
    } else if (isDict(val)) {
      clone[key] = processRequestData(val);
    } else if (val instanceof Array && val.length > 0 && isDict(val[0])) {
      clone[key] = val.map(elm => processRequestData(elm));
    }
  });
  return clone;
};


const createSlug = (item, [field, ...subFields]) => {
  if (!item || !field) return;

  const subItem = item[field];

  if (!subItem) return;

  if (subFields.length === 0) {
    if (typeof (subItem) === 'string') {
      item[`${field}_slug`] = removeAccent(subItem);
    }
    return;
  }

  if (isArray(subItem)) {
    subItem.forEach((si) => {
      createSlug(si, subFields);
    });

    return;
  }

  if (isDict(subItem)) {
    createSlug(subItem, subFields);
  }
};


/**
 * slugFields: ['a.b.c', ...]
 */
const processResponseData = (item, slugFields = []) => {
  if (!item || slugFields.length === 0) return item;

  slugFields.forEach((field) => {
    createSlug(item, field.split('.'));
  });

  return item;
};


const fetch = (options) => {
  const { data, url, ...newOptions } = options;

  newOptions.url = url.startsWith('http') ? url : (accApiUrl + url);
  if (url.startsWith(fileServiceUrl)) {
    newOptions.withCredentials = true;
  }

  if (data) {
    newOptions[newOptions.method.toLowerCase() === 'get' ? 'params' : 'data'] = processRequestData(data);
  }

  return axios(newOptions);
};

export default function request({ download, slugs, showError = true, ...rest }) {
  return fetch(rest).then((response) => {
    let { data } = response;

    if (download) {
      let fileName = download;
      if (!fileName && response.headers['content-disposition']) {
        fileName = response.headers['content-disposition'].replace('attachment; filename=', '');
      }

      downloadjs(data, fileName);

      data = null;
    }

    if (slugs) {
      data = processResponseData(data, slugs);
    }

    return isDict(data) ? { success: true, ...data } : { success: true, data };
  }).catch((e) => {
    const error = {};
    const { response } = e;

    if (response && response instanceof Object) {

      const { data, status, statusText } = response;

      if (data instanceof Blob) {
        try {
          data.text().then((text) => {
            const msg = JSON.parse(text);
            if (msg && msg.error_message) {
              notifyError(msg.error_message);
            }
          });
        } catch (e) {
          // Do nothing
        }
      } else if (data) {
        error.message = data.error_message;
        error.code = data.error_code;
        error.data = data.error_data;

        // TODO: handle error from Auth Service
        if (data.error) {
          Object.assign(error, data.error);
        }

        if (!error.message) error.message = statusText;
      }

      error.status = status;
    } else {
      error.status = 600;
      error.message = e.message;
    }

    console.log('request error', error, response);

    if (error.status === 600) {
      error.message = 'Lỗi kết nối mạng';
    } else if (error.status === 403) {
      error.message = 'Chức năng này chỉ dành cho kế toán';
    } else if (error.status === 404) {
      error.message = 'Dữ liệu không tồn tại';
    }

    if (error.status === 401) {
      // @HACK
      /* eslint-disable no-underscore-dangle */
      window.g_app._store.dispatch({
        type: 'app/clearAuth',
      });
    } else if (showError && error.message) {
      notifyError(error.message);
    }

    return { success: false, error };
  });
}

export function setCommonHeaders(headers) {
  Object.assign(axios.defaults.headers.common, headers);
}



// WEBPACK FOOTER //
// ./src/utils/request.js